import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesOffers } from "../../constants";
import { CreateSectionStyleBody } from "./createSectionStyle.types";

export const requestCreateSectionStyle = async (
  body: CreateSectionStyleBody
): Promise<void> => {
  return await instance.post(
    buildUrl(ApiRoutesOffers.SpecialOffers, ApiRoutesOffers.SectionStyle),
    body
  );
};
